/* group */
import genericGroupDeleteGroupById from './group/genericGroupDeleteGroupById';
import genericGroupDeleteRuleById from './group/genericGroupDeleteRuleById';
import genericGroupQueryBusinessTypeAll from './group/genericGroupQueryBusinessTypeAll';
import genericGroupQueryGroupBySourceAndErp from './group/genericGroupQueryGroupBySourceAndErp';
import genericGroupQueryRuleAll from './group/genericGroupQueryRuleAll';
import genericGroupSaveGroup from './group/genericGroupSaveGroup';
import genericGroupSaveRule from './group/genericGroupSaveRule';
import genericQueryGroupAll from './group/genericQueryGroupAll';
import genericGroupMessageGroupTip from './group/genericGroupMessageGroupTip';
import genericGroupQueryGroupById from './group/genericGroupQueryGroupById';
import genericGroupQueryGroupRuleByMsgCode from './group/genericGroupQueryGroupRuleByMsgCode';
/* message */
import genericMessageChangeGroup from './message/genericMessageChangeGroup';
import genericMessageChangeReadStatus from './message/genericMessageChangeReadStatus';
import genericMessageGroupMessageNum from './message/genericMessageGroupMessageNum';
import genericMessageList from './message/genericMessageList';
import searchGenericMessageList from './message/genericSearchMessageList';
import genericMessagePopup from './message/genericMessagePopup';
import genericMessageQueryMessage from './message/genericMessageQueryMessage';
import genericMessageTotalMessageNum from './message/genericMessageTotalMessageNum';
import genericMessageTypeNum from './message/genericMessageTypeNum';
import genericMarketTypeNum from './message/genericMarketTypeNum';
import genericMessageKindNum from './message/genericMessageKindNum';
import genericMessageReadStatus from './message/genericMessageReadStatus';
import genericMsgSettingList from './message/genericMsgSettingList';
import genericMsgSwitchStatus from './message/genericMsgSwitchStatus';
import genericMsgListSubcribe from './message/genericMsgSubscribeList';
import genericMsgSubcribeStatus from './message/genericMsgSubscribeStatus';

export default {
  /* group */
  genericGroupDeleteGroupById,
  genericGroupDeleteRuleById,
  genericGroupQueryBusinessTypeAll,
  genericGroupQueryGroupBySourceAndErp,
  genericGroupQueryRuleAll,
  genericGroupSaveGroup,
  genericGroupSaveRule,
  genericQueryGroupAll,
  genericGroupMessageGroupTip,
  genericGroupQueryGroupById,
  genericGroupQueryGroupRuleByMsgCode,
  /* message */
  genericMessageChangeGroup,
  genericMessageChangeReadStatus,
  genericMessageGroupMessageNum,
  genericMessageList,
  searchGenericMessageList,
  genericMessagePopup,
  genericMessageQueryMessage,
  genericMessageTotalMessageNum,
  genericMessageTypeNum,
  genericMarketTypeNum,
  genericMessageKindNum,
  genericMessageReadStatus,
  genericMsgSettingList,
  genericMsgSwitchStatus,
  genericMsgListSubcribe,
  genericMsgSubcribeStatus,
};
